(function($) {

    $(document).ready(function() {

        /*

        цели для Yandex Метрика - ekhlusov

        цели для GA - ekhlusov (файл называется я метрика, да)
        Пример: ga('send', 'event', [eventCategory], [eventAction], [eventLabel], [eventValue], [fieldsObject]);
        -- События для старого кода analytics.js (пока оставил)

        Для нового кода gtag.js пример:
        gtag('event', [eventAction], {
                                'event_category': [eventCategory],
                                'event_label': [eventLabel]
                               });

         Цели для старого кода Яндекс.Метрики (до 6.12.2018)
         reachGoal(target[, params[, callback[, ctx]]])
         Для нового кода:
         ym(XXXXXX, 'reachGoal', target[, params[, callback[, ctx]]]);

         */

        var pathName = window.location.pathname; // пусть для GA

        // ЭНРОЛЛМЕНТ
        // http://redmine.escc.ru/issues/3395

        // факт начала заполнения формы
        $(document).on('focus', '.common-form input[name="name"]', function() {

            var goal_id = 'try-to-edit-form';

            //yaCounter206895.reachGoal( goal_id );
            ym(206895, 'reachGoal', goal_id);

            return true;

        });

        // выбран помесячный или полный курс
        // вносим полученные параметры в метрику после отправки формы
        $(document).on('submit', 'form.common-form[name="orderForm"]', function () {

            var goal_id = 'form-collected';

            // получаем название курса
            var courseName = $('.common-form .common-form__course-field-wrapper select option:selected').text();

            if ( courseName != '' && courseName != 'Выберите курс' ) {
                var courseName = courseName;
            } else {
                var courseName = 'Err - courseName';
            }

            // делаем проверку спсоб получения материалов
            var receiptType = $('.common-form input[name="receiptType"]:checked').val();

            switch ( receiptType ) {
                case '0':
                    var receiptType = 'Помесячное обучение';
                    break;
                case '1':
                    var receiptType = 'Полный курс сразу';
                    break;
                default:
                    var receiptType = 'Err - receiptType';
            }

            // проверка вида доставки
            var shipmentType = $('.common-form input[name="shipmentType"]:checked').val();

            switch ( shipmentType ) {
                case '1':
                    var shipmentType = 'Наложенный платеж';
                    break;
                case '2':
                    var shipmentType = 'Ценная посылка';
                    break;
                case '3':
                    var shipmentType = 'Курьерская доставка';
                    break;
                default:
                    var shipmentType = 'Err - shipmentType';

            }

            // способ выполнения ДР
            var hwType = $('.common-form input[name="hwType"]:checked').val();

            switch ( hwType ) {
                case '0':
                    var hwType = 'Письменно на печатных бланках';
                    break;
                case '1':
                    var hwType = 'В режиме онлайн';
                    break;
                default:
                    var hwType = 'Err - hwType';
                    break;
            }

            // темп обучения
            var tempo = $('.common-form input[name="tempo"]:checked').val();

            switch ( tempo ) {
                case '0':
                    var tempo = 'Нормальный';
                    break;
                case '1':
                    var tempo = 'Ускоренный-2';
                    break;
                case '2':
                    var tempo = 'Ускоренный-3';
                    break;
                default:
                    var tempo = 'Err - tempo';
                    break;
            }

            // параметры для метрики
            var goalParams = {
                courseName: courseName,
                receiptType: receiptType,
                shipmentType: shipmentType,
                hwType: hwType,
                tempo: tempo
            };

            //yaCounter206895.reachGoal(goal_id, goalParams);
            ym(206895, 'reachGoal', goal_id, goalParams);

            return true;
        });


        // указаны email и телефон
        $(document).on('keyup', '.common-form input[name="email"], .common-form input[name="phone"]', function() {

            var goal_id = 'email-and-phone-entered';
            var userEmail = $('.common-form input[name="email"]').val();
            var userPhone = $('.common-form input[name="phone"]').val();

            if ( userEmail && userPhone && userEmail.length > 6 && userPhone.length > 10 ) {

                var goalParams = {
                    userEmail: true,
                    userPhone: true
                };

                //console.log('Указаны email и телефон. Goal: ' + goal_id + ' | ' + userEmail + ', ' + userPhone);

                //yaCounter206895.reachGoal(goal_id, goalParams);
                ym(206895, 'reachGoal', goal_id, goalParams);

                return true;
            }


        });

        // получаем название курса со страницы посещения
        $(window).load(function() { // раньше window load не хочет срабатывать
            if ( window.location.pathname.indexOf("/katalog/products/") > -1 && $('h1').hasClass('catalog-course__h1-title') ) {

                var goal_id = 'visiting-course-page';
                var coursePageNameh1 = $('meta[itemprop="name"]').attr('content');

                var coursePageParams = {
                    coursePageName: coursePageNameh1
                };

                //yaCounter206895.reachGoal(goal_id, coursePageParams);
                ym(206895, 'reachGoal', goal_id, coursePageParams);

                return true;
            }
        });


        // Регистрации и активность на сайте
        // http://redmine.escc.ru/issues/3396
        // переход в домашние работы онлайн
        $(document).on('click', 'a[href*="homework.escc.ru"]', function () {
            var goal_id = 'entered-homework';

            //yaCounter206895.reachGoal(goal_id);
            ym(206895, 'reachGoal', goal_id);

            return true;
        });

        // переход в кампус
        $(document).on('click', 'a[href*="campus.escc.ru"]', function () {
            var goal_id = 'entered-campus';

            //yaCounter206895.reachGoal(goal_id);
            ym(206895, 'reachGoal', goal_id);

            return true;
        });


        // ОПЛАТА
        // http://redmine.escc.ru/issues/3394

        // Переход с ссылки «Способы оплаты» на главной странице
        $(document).on('click', '.l-1-item a[href*="sposoby-oplaty"]', function () {
            var goal_id = 'from-SO-left-menu';

            //yaCounter206895.reachGoal(goal_id);
            ym(206895, 'reachGoal', goal_id);

            return true;

        });

        // Клик по баннеру "Оплатить онлайн" в каруселе
        $(document).on('click', '#pay-online-banner', function () {
            var goal_id = 'pay-online-banner-click';

            //yaCounter206895.reachGoal(goal_id);
            ym(206895, 'reachGoal', goal_id);

            return true;

        });

        // есть ли в Cookie SID ( => пользователь активный студент )
        $(window).load(function() {
            if  ( readCookie('SID') && readCookie('client_code') ) {
                var goal_id = 'active-student';

                //yaCounter206895.reachGoal(goal_id);
                ym(206895, 'reachGoal', goal_id);

                return true;
            }

        });

    });


    // функция чтения cookie
    function readCookie(name) {
        var nameEQ = encodeURIComponent(name) + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    }

})(jQuery);
